// @flow

import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '../hooks/useQuery';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const PAYMENT = `
query GetPayment($paymentId: String!) {
    lookupPayment(paymentId: $paymentId)
}
`;

const StripeDetail = () => {
  const { paymentId } = useParams();

  const { data } = useQuery(PAYMENT, {
    variables: { paymentId }
  });

  if (!paymentId) {
    return null;
  }

  const payment = data && data.lookupPayment ? data.lookupPayment : {};
  const keys = Object.keys(payment);

  return (
    <Paper>
      <Table>
        <TableBody>
          {keys.map((v) => {
            return (
              <TableRow key={v} style={{ margin: '5px' }}>
                <TableCell>{v}</TableCell>
                <TableCell>{JSON.stringify(payment[v])}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default StripeDetail;